/**
 *
 * @param   {number} value
 * @returns                The "compact" version of the given number (e.g. 13M or 2.5B), truncated to
 *                         a maximum of 3 decimal places. If the number is already compact, it will be unchanged.
 */
export const compactify = (value) => Intl.NumberFormat(undefined, {
  compactDisplay: 'short',
  maximumFractionDigits: 3,
  notation: 'compact',
  unitDisplay: 'narrow'
}).format(value);

/**
 * @param   {number} bytes
 * @returns                The given bytes in GiB.
 */
export const bytesToGiB = (bytes) => (bytes / Math.pow(1024, 3)).toFixed(2);

/**
 * Formats an XML string with indentation for better readability.
 *
 * @param   {string} xml
 * @returns {string}     Formatted XML string with indentation.
 */
export const formatXml = (xml) => {
  let formatted = '';
  let indent = '';
  const tab = '  '; // use 2 spaces for indentation
  xml.split(/>\s*</).forEach(node => {
    if (node.match( /^\/\w/ )) indent = indent.substring(tab.length); // decrease indent by one 'tab'
    formatted += indent + '<' + node + '>\r\n';
    if (node.match( /^<?\w[^>]*[^/]$/ )) indent += tab;              // increase indent
  });
  return formatted.substring(1, formatted.length - 3);
};
